import React, {Component} from 'react';
import { SIGNIN, MSSIGNIN } from '../core/handlers.actions';
import { connect } from 'react-redux';
import {Redirect} from 'react-router-dom';
import { UserAgentApplication } from 'msal';
import { ImplicitMSALAuthenticationProvider } from '@microsoft/microsoft-graph-client/lib/src/ImplicitMSALAuthenticationProvider';
import { Client } from "@microsoft/microsoft-graph-client";
import {MSALAuthenticationProviderOptions} from '@microsoft/microsoft-graph-client/lib/src/MSALAuthenticationProviderOptions';
import {Container, TextField, withStyles, Button, CssBaseline, Avatar, Typography, Paper} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Alert from '@material-ui/lab/Alert/Alert';

interface IUser {
    user: {
         firstName:String;
         lastName:String;
         username:String;
         email:String;
    }     
}

const msalConfig = {
    auth: {
         clientId: 'ef395ae6-112e-415f-b087-eb2763d7b1ba',
         redirectUri: `${window.location.origin}/login`
    }
}

const graphScopes = ['profile', 'user.read'];
const msalApplication = new UserAgentApplication(msalConfig);
const options = new MSALAuthenticationProviderOptions(graphScopes);
const authProvider = new ImplicitMSALAuthenticationProvider(msalApplication, options);

const option = { authProvider};
const client = Client.initWithMiddleware(option);
const styles = (theme:any) => ({ 
    paper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(8),          
        flexDirection: 'column' as 'column'    
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    pageBackground: { padding: theme.spacing(3)},
    alertError: { marginTop: theme.spacing(2)}
});

interface Props {
    logIn: (user: State) => void;
    user: any;
    msSignIn: (user:IUser) => void;
    classes: any;
}

interface State {
    email?: string | null;
    password?: string | null;
}


class Login extends Component<Props, State> {
    static state: State = {email: '', password: ''};
    constructor(props: Props) {
        super(props);
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.loginWithMS = this.loginWithMS.bind(this);
    }

    public onChangeHandler(e: any) {
        this.setState({...this.state, [e.target.name]: e.target.value});
    }

    public async loginWithMS(){         
        const {msSignIn} = this.props;
        try {
             
             let userDetails = await client.api('/me').get();
             const user:IUser = {
                  user: {
                       firstName: userDetails.givenName,
                       lastName: userDetails.surname,
                       username: userDetails.userPrincipalName,
                       email: userDetails.mail || userDetails.userPrincipalName
                  }                   
             };
             msSignIn(user);
        } catch (error) {  
            console.log(error);                      
            throw error;
        }
    }

    public render(){
        const { logIn, user, classes } = this.props;        
        if(user.session) return <Redirect to={{pathname: '/'}}/>       
        return(
            <Container component="main" maxWidth="xs" >
                <Paper className={classes.pageBackground}>
                    <CssBaseline />
                    <div className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Sign in
                        </Typography>
                        <form className={classes.form} noValidate autoComplete="off">
                            <TextField onChange={this.onChangeHandler} margin="normal" autoComplete="email" autoFocus required fullWidth id="email" name="email" label="Email Address" type="email" />
                            <TextField onChange={this.onChangeHandler}  margin="normal" required fullWidth type="password" id="password" name="password" label="Password" autoComplete="current-password" />
                            <Button fullWidth variant="outlined" color="primary" className={classes.submit} onClick={() => logIn(this.state)} endIcon={<ArrowForwardIcon />}> Continue </Button>
                        </form>
                        <strong style={{marginTop: '1em', marginBottom: '1em'}}>or</strong>
                        <Button variant="outlined" fullWidth className="microsoft-login-button" onClick={this.loginWithMS}><span>Microsoft SSO</span></Button>
                    </div>                
                    {user.error? (<Alert className={classes.alertError} severity="error">Error invalid credentials</Alert>):null}
                </Paper>            
            </Container>
        );
    }
}

const mapToProps = (app:any) => ({user: app.rootReducer.user});
const mapToDispatch = (dispatch: any) => ({
     logIn: (user: State) => dispatch({ type: SIGNIN, payload: user }),
     msSignIn: (user:IUser) => dispatch({type: MSSIGNIN, payload:user})
});
export default connect(mapToProps, mapToDispatch)(withStyles(styles)(Login));